import { services } from '@/service';
import router from './router';

const curLoadTime = Date.now();
const storageKey = 'LOAD_TAB_ARR';
const checkKeyPre = `crash_check_`;
let checkTimeout = 0;

router.afterEach((to, from) => {
  const tabArr = JSON.parse(localStorage.getItem(storageKey) || '[]');
  const idx = tabArr.findIndex(item => item.timestamp === curLoadTime);
  if (idx === -1) {
    tabArr.push({ to, from, timestamp: curLoadTime });
    checkOtherTab(tabArr);
  } else {
    tabArr.splice(idx, 1, { to, from, timestamp: curLoadTime });
  }
  localStorage.setItem(storageKey, JSON.stringify(tabArr));
});


window.addEventListener("unload", () => {
  if (checkTimeout) {
    clearTimeout(checkTimeout);
  }
  let tabArr = JSON.parse(localStorage.getItem(storageKey) || '[]');
  tabArr = tabArr.filter(item => item.timestamp !== curLoadTime);
  localStorage.setItem(storageKey, JSON.stringify(tabArr));
});

function checkOtherTab(tabArr) {
  const checkKeys = [];
  tabArr.forEach((item) => {
    if (item.timestamp !== curLoadTime) {
      const key = `${checkKeyPre}${item.timestamp}`;
      checkKeys.push(key)
      localStorage.setItem(key, JSON.stringify(item));
    }
  });
  checkTimeout = setTimeout(() => {
    const crashTabs = [];
    checkKeys.forEach(key => {
      const info = localStorage.getItem(key);
      if (info) {
        crashTabs.push(JSON.parse(info));
        localStorage.removeItem(key);
      }
    });
    const crashTabTimeArr = crashTabs.map(item => item.timestamp);
    let tabArr = JSON.parse(localStorage.getItem(storageKey) || '[]');
    tabArr = tabArr.filter(item => !crashTabTimeArr.includes(item.timestamp));
    localStorage.setItem(storageKey, JSON.stringify(tabArr));
    crashTabs.forEach(item => {
      services.logger.crashLog(item);
    });
  }, 1000);
}

window.addEventListener("storage", function(e) {
  const checkItem = localStorage.getItem(`${checkKeyPre}${curLoadTime}`);
  if (checkItem) {
    localStorage.removeItem(`${checkKeyPre}${curLoadTime}`);
  }
});



// WEBPACK FOOTER //
// ./src/crashListener.js